import { EventEmitter } from "../helpers/EventEmitter";
import { AppEvents } from "../types/events";


export const appEventEmitter = new EventEmitter<AppEvents>();
